import { IEnvironment } from '@common/types/environment';

export const environment: IEnvironment = {
  production: true,
  keycloak: {
    url: 'https://sso.oilsat.ru/auth/',
    realm: 'ucp',
    clientId: 'base'
  },
  api: 'https://api.kom.oilsat.ru',
  calendarApi: 'https://api.cal.oilsat.ru',
  constructorApi: 'https://forms.efko.ru',
  taskManagerApi: 'https://api.tasks.efko.ru',
  wsHost: 'wss://centrifugo.oilsat.ru',
  jitsuLogging: {
    hostUrl: 'https://jitsu.efko.ru',
    apiKey: 'zBuOZDPIbSnw02MnJUKoF2Myt3QT9myr:CaRdqVOU9b4YkWtP7ciE154shIpw4Rq1'
  },
  jitsiUrl: 'meet.oilsat.ru'
};
